export default "__VITE_ASSET__B6Y2SYq7__"